(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("subsidenavbar", [], factory);
	else if(typeof exports === 'object')
		exports["subsidenavbar"] = factory();
	else
		root["subsidenavbar"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 